export default "__VITE_ASSET__0667b009__"